







import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class LabelCount extends Vue {
  public name: string = "LabelCount";

  @Prop({required: true})
  public total!: string|number;

  @Prop({required: false, default: -1})
  public ofTotal!: number;

  @Prop({required: true})
  public label!: string;


}
